import isEqual from 'lodash.isequal';

const calculatePromises = (setLoading, loading, setBreadcrumbs, oldBreadcrumbs, promises) => {
  const newBreadcrumbs = [...promises];
  const unresolvedPromises = {};
  for (let i = 0; i < promises.length; i++) {
    const promise = promises[i].title;
    if (promise && typeof promise.then === 'function') {
      unresolvedPromises[i] = true;
      promise.then(title => {
        unresolvedPromises[i] = false;
        newBreadcrumbs[i].title = title;
        if (Object.values(unresolvedPromises).filter(o => o).length === 0) {
          if (loading) {
            setLoading(false);
          }
          if (!isEqual(oldBreadcrumbs, newBreadcrumbs)) {
            setBreadcrumbs(newBreadcrumbs);
          }
        }
      });
    }
  }
  if (Object.keys(unresolvedPromises).length === 0) {
    if (loading) {
      setLoading(false);
    }
    if (!isEqual(oldBreadcrumbs, newBreadcrumbs)) {
      setBreadcrumbs(newBreadcrumbs);
    }
  }
};

export { calculatePromises };
